/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import { Loader } from '../../atoms/Loader/Loader';
import './StatCardStyles.scss';
const BASE_CLASS = 'qmb-ui-stat-card';
export function StatCard({ variant = 'static', value, label, trend, trendDirection, trendSentiment = 'neutral', isLoading = false, onClick, className }) {
    const rootClass = classNames(BASE_CLASS, `${BASE_CLASS}--${variant}`, className);
    const showArrow = trendDirection && trendDirection !== 'neutral';
    const arrowIcon = trendDirection === 'up' ? 'fa-arrow-up' : 'fa-arrow-down';
    const trendClass = classNames(`${BASE_CLASS}__trend`, `${BASE_CLASS}__trend--${trendSentiment}`);
    const body = isLoading ? (React.createElement("div", { className: `${BASE_CLASS}__loading` },
        React.createElement(Loader, { size: "32" }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${BASE_CLASS}__top-row` },
            React.createElement("span", { className: `${BASE_CLASS}__value` }, value),
            trend && (React.createElement("span", { className: trendClass },
                showArrow && React.createElement("i", { className: `fa-solid ${arrowIcon}` }),
                trend))),
        React.createElement("div", { className: `${BASE_CLASS}__bottom-row` },
            React.createElement("span", { className: `${BASE_CLASS}__label` }, label),
            variant === 'interactive' && (React.createElement("span", { className: `${BASE_CLASS}__chevron` },
                React.createElement("i", { className: "fa-solid fa-chevron-right" }))))));
    if (variant === 'interactive') {
        return (React.createElement("button", { type: "button", className: rootClass, onClick: onClick }, body));
    }
    return React.createElement("div", { className: rootClass }, body);
}
